import { AlternateRecipe } from '@/types/alternate-recipe';

/**
 * Resolve macro value from various possible formats
 */
const resolveMacroValue = (value: number | { quantity?: number } | undefined): number | undefined => {
  if (typeof value === 'number') {
    return value;
  }
  if (typeof value === 'object' && value !== null && 'quantity' in value) {
    return value.quantity;
  }
  return undefined;
};

/**
 * Get macro value from alternate recipe with fallback logic
 */
export const getAlternateMacroValue = (
  recipe: AlternateRecipe,
  macro: 'calories' | 'protein' | 'carbs' | 'fat' | 'fiber'
): number | undefined => {
  const directValue = resolveMacroValue(
    (recipe as Record<string, unknown>)[macro] as number | { quantity?: number }
  );
  if (typeof directValue === 'number') {
    return directValue;
  }

  const macrosBlock = recipe.macros?.[macro];
  const macrosValue = resolveMacroValue(macrosBlock as number | { quantity?: number });
  if (typeof macrosValue === 'number') {
    return macrosValue;
  }

  if (macro === 'calories') {
    const nutritionCalories = resolveMacroValue(recipe.nutrition?.calories);
    if (typeof nutritionCalories === 'number') {
      return nutritionCalories;
    }
  } else {
    const nutritionMacrosValue = resolveMacroValue(
      recipe.nutrition?.macros?.[macro] as number | { quantity?: number }
    );
    if (typeof nutritionMacrosValue === 'number') {
      return nutritionMacrosValue;
    }
  }

  return undefined;
};

